var map = {
	"./1.jpg": "732b",
	"./10.jpg": "2665",
	"./2.jpg": "5227",
	"./3.jpg": "1675",
	"./4.jpg": "153c",
	"./5.jpg": "c45b",
	"./6.jpg": "5a0f",
	"./7.jpg": "7e38",
	"./8.jpg": "bdc0",
	"./9.jpg": "1f25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "015e";